import { Box, Image } from '@chakra-ui/react';
import moment, { Moment } from 'moment';
import Carousel from 'presentation/components/shared/Carousel/Carousel';
import { FC, useState } from 'react';
import EventCalendarMonthItem from './EventCalendarMonthItem';
import arrowBack from 'assets/img/icons/chevron-back-black.svg';

const oneDaySeconds = 60 * 60 * 24;
const today = moment().startOf('D');
const lastDay = moment().add(3, 'M').startOf('D');
const dates: Moment[][] = [];
for (let i = today.unix(); i < lastDay.unix(); i += oneDaySeconds) {
  if (dates.length === 0) {
    dates.push([moment.unix(i)]);
    continue;
  }
  const prevDate = dates[dates.length - 1][dates[dates.length - 1].length - 1];
  if (prevDate.isSame(moment.unix(i), 'M')) {
    dates[dates.length - 1].push(moment.unix(i));
  } else {
    dates.push([moment.unix(i)]);
  }
}

interface Props {
  events: ScheduledEventItem[];
  onEventClick: (eventId: ID) => void;
  containerWidth?: number;
  scrollBy?: number;
}

const EventCalendarCarousel: FC<Props> = ({
  events,
  onEventClick,
  containerWidth = 720,
  scrollBy = 684,
}) => {
  const [scrollLeft, setScrollLeft] = useState(0);

  return (
    <Box maxW={`${containerWidth}px`} px="20px">
      <Carousel
        scrollBy={scrollBy}
        onScroll={(elem) => {
          setScrollLeft(elem.scrollLeft);
        }}
        renderControls={({ prevControlHandler, nextControlHandler }) => {
          return (
            <>
              <Box
                pos="absolute"
                top="40px"
                zIndex="15"
                w="32px"
                h="32px"
                left="-32px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                onClick={prevControlHandler}
                cursor="pointer"
              >
                <Image width="10px" src={arrowBack} alt="" stroke="#000" />
              </Box>
              <Box
                pos="absolute"
                top="40px"
                zIndex="15"
                w="32px"
                h="32px"
                right="-32px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                onClick={nextControlHandler}
                cursor="pointer"
              >
                <Image
                  width="10px"
                  src={arrowBack}
                  alt=""
                  transform="scaleX(-1)"
                />
              </Box>
            </>
          );
        }}
      >
        {dates.map((days, index) => {
          return (
            <EventCalendarMonthItem
              days={days}
              key={index}
              parentScrollLeft={scrollLeft}
              events={events}
              onEventClick={onEventClick}
            />
          );
        })}
      </Carousel>
    </Box>
  );
};

export default EventCalendarCarousel;
